module.exports = __webpack_public_path__ + "static/media/cablecar.d14870d5.png";